import { TextToSubscribeButtonElement } from "@redotech/redo-model/content-builder/element-schema";
import { memo } from "react";
import { BrandKitButton } from "../../brand-kit-button";
import { FormElementProps } from "./index";

export const TextToSubscribeButton = memo(function TextToSubscribeButton({
  element,
  brandKit,
  brandKitOverrides,
  submitting,
}: Pick<
  FormElementProps<TextToSubscribeButtonElement>,
  "element" | "brandKit" | "brandKitOverrides" | "onClose" | "submitting"
>) {
  return (
    <BrandKitButton
      brandKit={brandKit}
      hierarchy={element.hierarchy}
      onClick={async () => {
        if (navigator.share) {
          await navigator.share({
            title: element.text,
            text: element.subscribeMessage,
            url: window.location.href,
          });
        } else {
          console.log("navigator.share is not supported");
        }
      }}
      override={
        brandKitOverrides.buttons.enabled
          ? brandKitOverrides.buttons
          : undefined
      }
      pending={submitting}
      text={element.text}
      type={element.action === "submit-and-advance" ? "submit" : "button"}
    />
  );
});
